'use strict';

module.exports = function(angularModule) {
  angularModule.controller('ReviewFormsCtrl', function($scope, $q, $state, $location, user, reviewGenService, pagingService, updateService, adminSearchService, stringService, confirmService, userManagerService){
    var vm = this;
    vm.reviewFormSearchQuery = adminSearchService.getSearchQuery();
    vm.freshQuery = null;
    vm.accountSelected = false;
    vm.totalReviewFormsInResponse = null;
    vm.state = {
      loading : true,
      updating: false
    }
    vm.reviewFormExportConfig = {};

    vm.pageStrings = stringService.adminStrings();
    vm.updateDetails = updateService.getUpdateDetails();

    vm.accountConfig = {
      required : false,
      accountId : null,
      disableDropdown: false,
      showAccountSelection: false
    }

    vm.updateConfig = {
      entityId : null,
      pageOneResult : true
    }

    vm.canModifyForm = function(reviewForm) {
      return _.includes(user.permissions, 'UserManagement') || user.userId === reviewForm.creatorId
    }


    vm.deleteForm = function(reviewForm) {
      confirmService.confirm('Delete review form', `Are you sure you want to delete the review form, "${reviewForm.name}"?`, confirmService.DELETE)
        .then(response => {

          if (response) {
            vm.state.updating = true;
            reviewGenService.deleteReviewForm(reviewForm).then(function () {
              var updateInfo = {
                status: "Active",
                type: "reviewForm",
                title: "Review Form",
                destinationRole: "manage",
                notificationType: "detail",
                actions: [{action:"delete"}],
                entity: reviewForm,
                id: reviewForm._id,
                name: reviewForm.name,
                searchParam: reviewForm.name
              };
              updateService.registerSuccessfulUpdate(updateInfo,true);
              vm.refreshReviewForms(vm.reviewFormSearchQuery)
            }).finally(() => vm.state.updating = false);
          }
        });
    };

    vm.userMap = {};
    vm.refreshReviewForms = function (searchQuery) {
      vm.state.loading = true;
      vm.reviewFormSearchQuery = adminSearchService.getSearchQuery();
      vm.freshQuery = vm.reviewFormSearchQuery;

      var dataLoad = {
        reviewForms: reviewGenService.searchReviewForms({searchTextOpt: vm.reviewFormSearchQuery, limitOpt: 10000})
      };

      $q.all(dataLoad).then(function (response) {
        vm.state.loading = false;
        var reviewFormsList = response.reviewForms.data.forms;
        vm.reviewFormsPaged = pagingService.createPagingData(reviewFormsList, 15, 'name');
        if (pagingService.getCurrentPage()) {
          vm.reviewFormsPaged.currentPageNum = pagingService.getCurrentPage();
        }

        if (user.permissions.indexOf("UserManagement") >= 0) {
          userManagerService.getUsers(reviewFormsList.map(form => form.creatorId)).then(userMap => {
            vm.userMap = userMap
            reviewFormsList.forEach(form => {
              if (!vm.userMap[form.creatorId]) vm.userMap[form.creatorId] = {firstName: "Account", lastName: "Admin"}
            })
          })
        }

        vm.totalReviewFormsInResponse = reviewFormsList.length;

        if (vm.updateConfig.entityId) {
          if (_.where(vm.reviewFormsPaged.pagedItems[0], {id: vm.updateConfig.entityId}).length > 0) {
            vm.updateConfig.pageOneResult = true;
          }
        }

        var accountIdToPass = vm.accountConfig.accountId == "all" ? undefined : vm.accountConfig.accountId;

        vm.reviewFormExportConfig = {
          export: function () {
            return reviewGenService.exportReviewForms(accountIdToPass, vm.reviewFormSearchQuery);
          },
          accountId: accountIdToPass,
          reviewFormSearchQuery: vm.reviewFormSearchQuery
        };

      });
    }

    vm.updatePagingState = function() {
      pagingService.setCurrentPage(vm.reviewFormsPaged.currentPageNum);
    };

    vm.updateReviewForm = function (reviewForm) {
      reviewGenService.updateReviewForm(reviewForm).then(function () {
        vm.refreshReviewForms();
      });
    };

    vm.isUpdatedItemRow = function(id,entityId){
      return id==entityId;
    };

    vm.submitReview = function(generatedReview) {
      reviewGenService.submitReview(generatedReview)
    };

    vm.refreshReviewForms();


  });
};
